import { useCallback } from "react";
import { useI18nContext } from "@hopper-b2b/i18n";
import dayjs from "dayjs";

export const useGetTravelerType = () => {
  const { t } = useI18nContext();
  return useCallback(
    (dateOfBirth: string, relativeDate?: Date) => {
      const age = relativeDate
        ? dayjs(relativeDate).diff(dayjs(dateOfBirth), "year")
        : dayjs().diff(dateOfBirth, "year");
      if (age > 11) {
        return t("core-traveler.travelerType.adult");
      } else if (age >= 2) {
        return t("core-traveler.travelerType.child");
      } else if (age > 1) {
        return t("core-traveler.travelerType.infant");
      } else {
        return t("core-traveler.travelerType.infant");
      }
    },
    [t]
  );
};
